import React from "react";
import OnlineProgramCard from "./OnlineProgramCard";
import ClassroomProgamCard from "./ClassroomProgamCard";
import SurveyProgramCard from "./SurveyProgamCard";
import ActivityProgamCard from "./ActivityProgamCard";
import ProgamCard from "./ProgamCard";
import * as CONSTANTS from "../../../../constants";

const Card = (props) => {
  const { course } = props;

  const isSurvey = course.type === CONSTANTS.COURSE_TYPE_SURVEY_TO_COMPLETE;
  const TYPE_ACTIVITY =
    course.type === CONSTANTS.COURSE_TYPE_ACTIVITY ||
    course.type === CONSTANTS.COURSE_TYPE_COMMON_ACTIVITY ||
    course.type === CONSTANTS.COURSE_TYPE_NEW_COMMON_ACTIVITY;

  return (
    <>
      {course.type === CONSTANTS.COURSE_TYPE_ONLINE && (
        <OnlineProgramCard {...props} />
      )}
      {course.type === CONSTANTS.COURSE_TYPE_CLASSROOM && (
        <ClassroomProgamCard {...props} />
      )}
      {course.type === CONSTANTS.COURSE_TYPE_PROGRAM && (
        <ProgamCard {...props} />
      )}
      {isSurvey && <SurveyProgramCard {...props} />}
      {TYPE_ACTIVITY && <ActivityProgamCard {...props} />}
    </>
  );
};

export default Card;
